import { create } from 'zustand';

import {
  Lead,
  LeadBackground,
  LeadFinancial,
  LeadOtherFinancial,
} from '@/types/zee-candidate.type';

export interface LeadState {
  candidates: Lead[] | undefined;
  setCandidates: (candidates: Lead[]) => void;

  // Individual candidate for easier access
  candidate: Lead | undefined;
  setCandidate: (candidate: Lead) => void;

  // Financial data for zee candidate
  candidateFinancial: LeadFinancial | undefined;
  setCandidateFinancial: (financial: LeadFinancial) => void;

  candidateOtherFinancial: LeadOtherFinancial | undefined;
  setCandidateOtherFinancial: (otherFinancial: LeadOtherFinancial) => void;

  // Background data for zee candidate
  candidateBackground: LeadBackground | undefined;
  setCandidateBackground: (background: LeadBackground) => void;

  clearCurrentCandidateProfile: () => void;
}

const useLeadStore = create<LeadState>((set) => ({
  candidates: undefined,
  setCandidates: (candidates: Lead[]) => set(() => ({ candidates })),

  candidate: undefined,
  setCandidate: (candidate: Lead) => set(() => ({ candidate })),

  candidateFinancial: undefined,
  setCandidateFinancial: (candidateFinancial: LeadFinancial) =>
    set(() => ({ candidateFinancial })),

  candidateOtherFinancial: undefined,
  setCandidateOtherFinancial: (candidateOtherFinancial: LeadOtherFinancial) =>
    set(() => ({ candidateOtherFinancial })),

  candidateBackground: undefined,
  setCandidateBackground: (candidateBackground: LeadBackground) =>
    set(() => ({ candidateBackground })),

  clearCurrentCandidateProfile: () =>
    set(() => ({
      candidate: undefined,
      candidateFinancial: undefined,
      candidateOtherFinancial: undefined,
      candidateBackground: undefined,
    })),
}));

export default useLeadStore;
